import { css } from 'glamor'

export default {
  preloaderBlock: css({
    textAlign: 'center',
    transition: 'opacity .4s',
    opacity: '0',
  }),
  preloader: css({
    marginTop: '30px',
    width: '200px',
  }),
  showPreloader: css({
    opacity: '1',
  }),

  result: css({
    marginTop: '30px',
  }),
  text: css({
    color: '#D61852',
    fontFamily: "'Press Start 2P', cursive",
    marginBottom: '30px',
  }),
  controls: css({
    textAlign: 'center',
  }),
}



// WEBPACK FOOTER //
// ./src/components/Question/components/Result/styles.js